/* @flow */
import { API_URL } from '../../Constants';

export function fetchAutocompleteLocationInfo(googleId: string, address2: ?string) {
  return {
    url: `${API_URL}/locations/autocomplete/${googleId}`,
    body: { address2 },
    transform: (response: Object) => ({ locationsById: response, locationsByGoogleId: response }),
    update: {
      locationsById: (prevLocations: Object, location: Object) => ({
        ...prevLocations,
        [location.id]: location,
      }),
      locationsByGoogleId: (prevLocations: Object, location: Object) => ({
        ...prevLocations,
        [googleId]: {
          [address2]: location,
        },
      }),
    },
  };
}

export function fetchLocation(id: string) {
  return {
    url: `${API_URL}/locations/${id}`,
    transform: (response: Object) => ({
      locationsById: response,
      locationsByGooglePlaceId: response,
    }),
    update: {
      locationsById: (prevLocations: Object, location: Object) => ({
        ...prevLocations,
        [location.id]: location,
      }),
      locationsByGooglePlaceId: (prevLocations: Object, location: Object) => ({
        ...prevLocations,
        [location.google_place_id]: location,
      }),
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/locations/queries.js